<template>
  <div style="padding: 0 1rem">
    <b-row style="min-height: calc(100vh - 40px)">
      <b-col sm="12" lg="8" style="display: flex">
        <div class="center">
          <b-row style="margin-top: -50px">
            <b-col>
              <h1 style="font-weight: 800 !important" class="text-manrope">
                Indonesia Data Hub <span class="underline">(INDAH)</span>
              </h1>
              <p
                class="text-15 text-manrope text-medium text-600"
                style="
                  padding-bottom: 2rem;
                  letter-spacing: 0.4px;
                  margin-top: -20px;
                "
              >
                Indonesia Data Hub merupakan
                <i>one stop collaboration platform</i> yang bertujuan untuk
                meningkatkan literasi data dan <i>value of statistics</i>
                serta mendukung interoperabilitas data dan kolaborasi eksplorasi
                terhadap data.
              </p>

              <!-- Informasi Pembaruan Aplikasi -->
              <!-- Informasi Pembaruan Aplikasi -->
              <div 
                class="text-manrope"
                style="
                  background-color: #d4edda;
                  border-left: 4px solid #28a745;
                  padding: 0.25rem 0.5rem;
                  margin-bottom: 0.8rem;
                  border-radius: 2px;
                  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
                "
              >
                <p style="font-weight: 700; margin-bottom: 0.3rem; margin-top: 0; color: #155724; font-size: 13px;">
                  Informasi Pembaruan Aplikasi
                </p>
                <p style="margin-top: 0; margin-bottom: 0.8rem; line-height: 1.7; color: #155724; font-size: 11px;">
                  Dalam rangka meningkatkan layanan pengusulan standar data statistik dan pelaporan metadata statistik, 
                  kami informasikan bahwa <strong style="font-weight: 800;">pembaruan aplikasi akan dilakukan secara bertahap</strong>.
                </p>
                <p style="margin-bottom: 0.8rem; line-height: 1.7; color: #155724; font-size: 11px;">
                  Tahap awal pembaruan akan dimulai pada <strong style="font-weight: 800;">15 Oktober 2025</strong> melalui menu 
                  <strong style="font-weight: 800;">Standar Data Statistik (SDS)</strong>. Pada tanggal tersebut, <strong style="font-weight: 800;">Walidata Pusat</strong> dapat 
                  mengusulkan standar data, konsep, maupun klasifikasi melalui aplikasi baru. Menu SDS pada 
                  aplikasi ini akan diarahkan secara otomatis ke aplikasi baru. Akun pengguna untuk aplikasi baru (MS-SDS) telah dikirimkan ke email Walidata yang terdaftar di aplikasi INDAH.
                </p>
                <p style="margin-bottom: 0; line-height: 1.7; color: #155724; font-size: 11px;">
                  Perlu kami sampaikan bahwa <strong style="font-weight: 800;">pelaporan metadata statistik tetap dapat dilakukan melalui aplikasi INDAH</strong> hingga ada pemberitahuan lebih lanjut.
                </p>
              </div>

            </b-col>
          </b-row>
          <b-row style="padding-top: 1.5rem">
            <b-col>
              <!-- <b-card
                style="cursor: pointer"
                class="text-center mt-2"
                @click="$router.push('https://ms-sds.web.bps.go.id/sds')"
              >
                <b-img
                  style="width: 80px"
                  src="./img/application/standar-data.svg"
                  alt="Standar Data Statistik"
                ></b-img>
                <p style="font-weight: 500" class="mt-2 text-manrope text-13">
                  Standar Data Statistik
                </p>
              </b-card> -->
              <b-link 
                href="https://ms-sds.web.bps.go.id/sds" 
                target="_blank"
                style="text-decoration: none; color: inherit"
              >
                <b-card
                  style="cursor: pointer"
                  class="text-center mt-2"
                >
                  <b-img
                    style="width: 80px"
                    src="./img/application/standar-data.svg"
                    alt="Standar Data Statistik"
                  ></b-img>
                  <p style="font-weight: 500" class="mt-2 text-manrope text-13">
                    Standar Data Statistik
                  </p>
                </b-card>
              </b-link>
            </b-col>
            <b-col>
              <b-card
                style="cursor: pointer"
                class="text-center mt-2"
                @click="$router.push('/metadata')"
              >
                <b-img
                  style="width: 80px"
                  src="./img/application/metadata.svg"
                  alt="Metadata Statistik"
                ></b-img>
                <p style="font-weight: 500" class="mt-2 text-manrope text-13">
                  Metadata Statistik
                </p>
              </b-card>
            </b-col>
            <b-col>
              <b-card
                style="cursor: pointer"
                class="text-center mt-2"
                @click="$router.push('/sshi')"
              >
                <b-img
                  style="width: 55px"
                  src="./img/sshi/sshi.png"
                  alt="Statistik Hayati Indonesia"
                ></b-img>
                <p style="font-weight: 500" class="mt-2 text-manrope text-13">
                  Sistem Statistik Hayati Indonesia
                </p>
              </b-card>
            </b-col>
            <b-col cols="2"></b-col>
          </b-row>
        </div>
      </b-col>
      <b-col class="bg" sm="12" lg="4"> </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "HalamanAwal",
  data: () => {
    return {
      query: "",
    };
  },
  methods: {
    cari: function (e) {
      if (e.keyCode === 13) {
        this.search();
      }
    },
    search() {
      this.$router.push("/enterprise-search?query=" + this.query);
    },
  },
};
</script>